import { useSelector } from 'react-redux';
import { userSelector } from '../../shared/store/selectors';
import { scenariosSelector } from './store/selectors';
import { NO_FLAG } from '../../shared/constants';
import { lastClientIdSelector } from '../../userData/store/selectors';
import { useMemo } from 'react';
import { fromSearchString } from '../../shared/urlUtils';
import { useLocation } from 'react-router-dom';

export const zipObject = (keys, values) =>
  keys.reduce((obj, key, index) => {
    obj[key] = values[index];
    return obj;
  }, {});


export const canUserEditScenario = ({ scenarioId, scenarios, user }) => {
  const scenario = scenarios.find(scenario => scenario.scenarioId === Number(scenarioId));
  return scenario && (user.sso === scenario.createdSso || user.permissions.commands.canCreatePublicScenario);
};


export const useCanUserEditScenario = scenarioId => {
  const user = useSelector(userSelector);
  const scenarios = useSelector(scenariosSelector);

  return canUserEditScenario({ scenarioId, scenarios, user });
};

export const isScenarioImportable = ({ scenarioId, scenarios }) => {
  const scenario = scenarios.find(scenario => scenario.scenarioId === Number(scenarioId));

  return scenario && scenario.lockedFlag === NO_FLAG;
};

export const useIsScenarioImportable = scenarioId => {
  const scenarios = useSelector(scenariosSelector);

  return isScenarioImportable({ scenarioId, scenarios });
};

// eslint-disable-next-line valid-jsdoc
/**
 * @return {List<string>}
 */
export const useSelectedScenarioCompanyCodes = () => {
  const { search } = useLocation();
  return useMemo(() => fromSearchString(search, true)?.companyCodes ?? [], [search]);
};

// eslint-disable-next-line valid-jsdoc
/**
 * @return {List<string>}
 */
export const useSelectedScenarioCountryTaxType = () => {
  const { search } = useLocation();
  return useMemo(() => fromSearchString(search, true)?.countryTaxTypes ?? [], [search]);
};

export const uniqByFields = (list, fields) => {
  const NULL_PLACEHOLDER = '$NULL_PLACEHOLDER$';
  const map = {};
  const result = [];
  const get = (object, path) => path.reduce((result, pathElement) => {
    if (result) {
      return result[pathElement];
    }
    return null;
  }, object);
  const set = (object, path, value) => path.reduce((result, pathElement, index) => {
    if (index === path.length - 1) {
      result[pathElement] = value;
      return object;
    }
    if (!result[pathElement]) {
      result[pathElement] = {};
    }
    return result[pathElement];
  }, object);

  list.forEach(el => {
    if (get(map, fields.map(field => el[field] || NULL_PLACEHOLDER))) {
      return;
    }
    set(map, fields.map(field => el[field] || NULL_PLACEHOLDER), true);
    result.push(el);
  });

  return result;
};

export const useCurrentClientId = () => useSelector(lastClientIdSelector);
